import React, {useState} from "react";

import Table from "../common/Table";
import RowPhoto from "../common/TdImg";
import Input from "../common/TdInput";

const StudentsList = ({ data, editMode, query }) => {
  const [changes, setChanges] = useState(0); // to update component after calculation

  const renderResult = (state) => {
    switch (state) {
      case 0:
        return "ناکام";
      case 1:
        return "کامیاب";
      case 3:
        return "محروم";
    }
  };

    const calculateTotalScore = (row) => {
      let total = 0;

      ["class_activity", "homework", "mid_term", "final"]
          .forEach(value => {
              let parsed = Number.parseInt(row[value])
              if (!isNaN(parsed)) total += parsed;
          })

      row.total = total;
      setChanges(changes + 1);
    }

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "student_photo",
      label: "عکس",
      content: ({ student_photo }) => <RowPhoto src={student_photo} />,
    },
    { path: "student_name", label: "نام" },
    { path: "student_father_name", label: "نام پدر" },
    {
      path: "present_count",
      label: "فیصدی حاضری",
      content: ({ present_count }) => `${present_count}%`,
    },
    {
      path: "class_activity",
      label: "فعالیت صنفی",
      input: (e) => <Input type="number" data={e} max={10} name={"class_activity"} callback={()=>{calculateTotalScore(e)}}/>,
    },
    {
      path: "homework",
      label: "کارخانگی",
      input: (e) => <Input type="number" data={e} max={10} name={"homework"} callback={()=>{calculateTotalScore(e)}}/>,
    },
    {
      path: "mid_term",
      label: "وسط سمستر",
      input: (e) => <Input type="number" data={e} max={20} name={"mid_term"} callback={()=>{calculateTotalScore(e)}}/>,
    },
    {
      path: "final",
      label: "نهایی",
      input: (e) => <Input type="number" data={e} max={60} name={"final"}  callback={()=>{calculateTotalScore(e)}}/>,
    },
    { path: "total", label: "مجموع" },
    {
      path: "result",
      label: "نتیجه",
      content: ({ result }) => renderResult(result),
    },
    { path: "option" },
  ];

  return (
    <Table data={data} columns={columns} editMode={editMode} query={query} />
  );
};

export default StudentsList;
